import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { ColumnLayout } from "../components/Layout/ColumnLayout";
import { AppStore } from "../components/Settings/App/AppStore";
import { Page } from "./Page";

export const AppStorePage = ({ route }: { route?: string }) => {
    return (
        <Page title="Xola App Store">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>App Store</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>{(height) => <AppStore height={height} route={route} />}</ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
